var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphones1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "headphone",
    transform: "translate(-9948 -3537)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_583",
    "data-name": "Ellipse 583",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(9948 3537)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "headphone-2",
    "data-name": "headphone",
    transform: "translate(9985.297 3578.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19344",
    "data-name": "Path 19344",
    d: "M181,299.215h8.579v8.579H181Zm0,0",
    transform: "translate(-129.243 -213.655)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19345",
    "data-name": "Path 19345",
    d: "M241,299.215h8.579v8.579H241Zm0,0",
    transform: "translate(-172.086 -213.655)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19346",
    "data-name": "Path 19346",
    d: "M301,299.215h8.579v8.579H301Zm0,0",
    transform: "translate(-214.929 -213.655)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19347",
    "data-name": "Path 19347",
    d: "M172.093,64.114A55.84,55.84,0,0,0,152.142,21.49l5.333-7.043-3.561-2.567c-21.983-15.842-53.752-15.842-75.735,0l-3.561,2.567L79.95,21.49A55.84,55.84,0,0,0,60,64.114V111.3a8.579,8.579,0,0,0,17.157,0V68.4a8.549,8.549,0,0,0-8.323-8.526A47.267,47.267,0,0,1,85.12,28.32l4.993,6.595,3.674-2.371a39.8,39.8,0,0,1,44.805,0l3.388,2.371,4.993-6.595a47.265,47.265,0,0,1,16.286,31.557,8.549,8.549,0,0,0-8.323,8.526V111.3a8.579,8.579,0,0,0,8.579,8.579v8.579h-34.6v-4.289a12.868,12.868,0,1,0-25.736,0v12.868h68.914Zm0,0",
    transform: "translate(-42.843)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19348",
    "data-name": "Path 19348",
    d: "M482,254.555v34.121a21.254,21.254,0,0,0,0-34.121Zm0,0",
    transform: "translate(-344.171 -181.765)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19349",
    "data-name": "Path 19349",
    d: "M8.579,254.555a21.254,21.254,0,0,0,0,34.121Zm0,0",
    transform: "translate(0 -181.765)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones1);
export default __webpack_public_path__ + "static/media/headphones1.a2bd47d28bb81ead17551b2c3d451d25.svg";
export { ForwardRef as ReactComponent };